import axios from "axios";
import * as actions from "../constants/userConstants.js";

export const login = (email, password) => async (dispatch) => {
  try {
    dispatch({ type: actions.USER_LOGIN_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };

    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/users/login`,
      { email, password },
      config
    );

    dispatch({ type: actions.USER_LOGIN_SUCCESS, payload: data.user });
    localStorage.setItem("userInfo", JSON.stringify(data.user));
  } catch (error) {
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.data.message &&
      error.response.data.message.includes("Email not verified")
    ) {
      dispatch({
        type: actions.USER_LOGIN_FAIL,
        payload: error.response.data, // pass entire server error payload with resend cooldown
      });
    } else {
      dispatch({
        type: actions.USER_LOGIN_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  }
};


export const logout = () => async (dispatch) => {
  localStorage.removeItem("userInfo");
  dispatch({ type: actions.USER_LOGOUT });
};

export const register = (name, email, password, contactNumber) => async (dispatch) => {
  try {
    dispatch({ type: actions.USER_REGISTER_REQUEST });

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/users/register`,
      { name, email, password, contactNumber },
      config
    );

    // ✅ Send the email directly as userInfo to trigger OTP screen
    dispatch({ type: actions.USER_REGISTER_SUCCESS, payload: { email: data.email } });

  } catch (error) {
    dispatch({
      type: actions.USER_REGISTER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};


export const userDetailsLoggedIn = () => async (dispatch, getState) => {
  try {
    dispatch({ type: actions.USER_LOGGED_IN_FAIL });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/users/profile`, config);

    dispatch({ type: actions.USER_LOGGED_IN_SUCCESS, payload: data.user });
  } catch (error) {
    dispatch({
      type: actions.USER_LOGGED_IN_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getUserDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: actions.USER_DETAILS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/users/${id}`, config);

    dispatch({ type: actions.USER_DETAILS_SUCCESS, payload: data.user });
  } catch (error) {
    dispatch({
      type: actions.USER_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateProfile = (user) => async (dispatch, getState) => {
  try {
    dispatch({ type: actions.USER_UPDATE_PROFILE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/users/profile`, user, config);

    dispatch({ type: actions.USER_UPDATE_PROFILE_SUCCESS, payload: data.user });
    localStorage.setItem("userInfo", JSON.stringify(data.user));
  } catch (error) {
    dispatch({
      type: actions.USER_UPDATE_PROFILE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const listUsers = () => async (dispatch, getState) => {
  try {
    dispatch({ type: actions.USER_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/users`, config);

    dispatch({ type: actions.USER_LIST_SUCCESS, payload: data.users });
  } catch (error) {
    dispatch({
      type: actions.USER_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const deleteUser = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: actions.USER_DELETE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/users/${id}`, config);

    dispatch({ type: actions.USER_DELETE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: actions.USER_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateUser = (userData) => async (dispatch, getState) => {
  try {
    dispatch({ type: actions.USER_UPDATE_PROFILE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/api/users/${userData._id}`,
      userData,
      config
    );

    dispatch({ type: actions.USER_UPDATE_SUCCESS });
    dispatch({ type: actions.USER_DETAILS_SUCCESS, payload: data.user });
  } catch (error) {
    dispatch({
      type: actions.USER_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};


export const verifyEmailOTP = (email, otp) => async (dispatch) => {
  try {
    dispatch({ type: 'USER_VERIFY_OTP_REQUEST' });

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/users/verify-email`,
      { email, otp },
      config
    );

    dispatch({ type: 'USER_VERIFY_OTP_SUCCESS', payload: data.user });
    dispatch({ type: 'USER_LOGIN_SUCCESS', payload: data.user });

    localStorage.setItem('userInfo', JSON.stringify(data.user));
  } catch (error) {
    dispatch({
      type: 'USER_VERIFY_OTP_FAIL',
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};


export const resendOtp = (email) => async (dispatch) => {
  try {
    dispatch({ type: "USER_RESEND_OTP_REQUEST" });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/users/resend-otp`,
      { email },
      config
    );

    dispatch({ type: "USER_RESEND_OTP_SUCCESS", payload: data.message });
  } catch (error) {
    dispatch({
      type: "USER_RESEND_OTP_FAIL",
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
